"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BoxSectionSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const BoxHeadingWrapper = (0, _mui.styled)('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const BoxWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        border: "1px solid ".concat(theme.palette.grey[200]),
        borderRadius: theme.spacing(2),
        padding: theme.spacing(4, 3),
        backgroundColor: theme.palette.background.paper,
        pointerEvents: 'auto'
    };
});
const AddressWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(3)
    };
});
const SkeletonImage = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        marginRight: theme.spacing(2)
    };
});
const SkeletonPrice = (0, _mui.styled)(_mui.Skeleton)({
    marginLeft: 'auto'
});
const StockWrapper = (0, _mui.styled)('div')({
    display: 'flex',
    justifyContent: 'space-between'
});
const AdditionalInfo = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        marginTop: theme.spacing(4),
        paddingTop: theme.spacing(3),
        borderTop: "1px solid ".concat(theme.palette.grey[200])
    };
});
const BoxSectionSkeleton = (props)=>{
    const { isDelivery } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BoxHeadingWrapper, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                        animation: "wave",
                        variant: "text",
                        width: 130,
                        height: 30
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                        animation: "wave",
                        variant: "text",
                        width: 80,
                        height: 21
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BoxWrapper, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AddressWrapper, {
                        children: [
                            isDelivery ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonImage, {
                                animation: "wave",
                                variant: "circular",
                                width: 45,
                                height: 45
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        width: 150,
                                        height: 21
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        width: 150,
                                        height: 21
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        width: 100,
                                        height: 21
                                    })
                                ]
                            }),
                            isDelivery ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonPrice, {
                                animation: "wave",
                                variant: "text",
                                width: 65,
                                height: 24
                            }) : null
                        ]
                    }),
                    isDelivery ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StockWrapper, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        width: 100,
                                        height: 24
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        width: 65,
                                        height: 24
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AdditionalInfo, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonImage, {
                                        animation: "wave",
                                        variant: "circular",
                                        width: 20,
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        width: 150,
                                        height: 21
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
exports.BoxSectionSkeleton = BoxSectionSkeleton;
